class NavigatorHelper {
    public async copyToClipboardAsync(selectedText?: string): Promise<void> {
        if (!selectedText) { return; }
        await navigator.clipboard.writeText(selectedText);
    }
}

export const NavigatorHelperSingleton = new NavigatorHelper();
